"use client";

import { PiggyBank, Receipt, Target, TrendingUp, Wallet } from "lucide-react";

import { AnimatedSectionDescription } from "@/components/app-shell/AnimatedSectionDescription";
import { ChartSection } from "@/components/app-shell/ChartSection";
import { SummaryCard } from "@/components/app-shell/SummaryCard";
import { formatCurrency, useBudgetData } from "@/components/app-shell/useBudgetData";

export function DashboardOverviewSection({ embedded = false }: { embedded?: boolean }) {
  const {
    totalSavings,
    totalInvestments,
    totalGoalSaved,
    totalGoalTarget,
    monthlyExpenseTotal,
    monthlySavingsTotal,
    goalCount,
  } = useBudgetData();

  const averageGoalProgress = totalGoalTarget > 0 ? Math.round((totalGoalSaved / totalGoalTarget) * 100) : 0;

  return (
    <section className={embedded ? "border-t border-border/60 pt-10" : ""}>
      <div className={embedded ? "mx-auto max-w-7xl px-6 pb-6" : "mx-auto max-w-7xl p-6"}>
        <div className="mb-6">
          <h1 className="mb-1 text-card-foreground">{embedded ? "Dashboard Overview" : "Dashboard"}</h1>
          <AnimatedSectionDescription className="text-sm text-muted-foreground">
            {embedded
              ? "Your full dashboard stays visible here too, so you can keep the big picture in view while working in this section."
              : "A full overview of the same savings, investments, expenses, and goals you already store in Convex."}
          </AnimatedSectionDescription>
        </div>

        <div className="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-5">
          <SummaryCard title="Total Savings" value={formatCurrency(totalSavings)} icon={<PiggyBank className="size-4" />} accentColor="blue" />
          <SummaryCard title="Total Investments" value={formatCurrency(totalInvestments)} icon={<Wallet className="size-4" />} accentColor="green" />
          <SummaryCard title="Monthly Savings" value={formatCurrency(monthlySavingsTotal)} icon={<TrendingUp className="size-4" />} accentColor="green" />
          <SummaryCard title="Monthly Expenses" value={formatCurrency(monthlyExpenseTotal)} icon={<Receipt className="size-4" />} accentColor="red" />
          <SummaryCard
            title="Goal Progress"
            value={`${averageGoalProgress}%`}
            subtitle={`${goalCount} goals tracked`}
            icon={<Target className="size-4" />}
            accentColor="amber"
          />
        </div>

        <ChartSection />

      </div>
    </section>
  );
}
